import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserRolesService } from '@bp-core/src/lib/services/portal/user-roles.service';
import { isSudoAccessDeferred } from 'bp/shared/guards/sudo-access.guard';

/**
 * Permite el acceso al módulo `oauth-clients` EXCLUSIVAMENTE a usuarios con rol `sudo`
 * (la administración de clients OAuth es la operación más sensible del panel). Caso
 * contrario redirige a `/errors/401`. Complementa el ocultamiento del menú en
 * `bp.component.ts` y la validación de rol `sudo` que hace el backend en cada endpoint.
 *
 * En una carga directa, mientras los permisos del sudo no llegan, cede el paso: el layout revalida la
 * URL con los permisos y lleva a la persona a su inicio (feature 057, H4).
 */
export const sudoGuard: CanActivateFn = () => {
  const rolesService = inject(UserRolesService);
  const router = inject(Router);

  if (rolesService.isSudo() || isSudoAccessDeferred()) {
    return true;
  }
  router.navigate(['/errors/401']);
  return false;
};
